<template>
<!--		class="-kropp-utan-pad-right-left-bottom"
		:class="{ 'b-350-plus': el.is.bredd350plus, 'h-260-plus':el.is.hojd260plus }"-->

	<eui-panel
		:vp-inaktiverad="skaVaraInaktiverad"
		:disabled="skaVaraInaktiverad"
		:vp-osynlig="skaVaraOsynlig"
		:class="{
			'-osynlig':skaVaraOsynlig
		}"

		:vp-visa-menyfaltet="vpArIRedigeralage"
		:vp-meny-config.sync="menyConfig"

		style="width: 100%; height: 100%;"

		@menyalternativ-valt-i-panel="onMenyalternativValtIPanel"
	>
		<template #huvudtext>
			<span class="ellipsis">Leverantörsskulder ({{ vpWidgetData.accountid }}<!-- {{ vpWidgetData.accountname }}-->)</span>
			<!--<span v-if="vpArIRedigeralage" @click="onDeleteWidget" style="float: right; cursor:pointer;">X</span>-->
		</template>

		<!-- Kroppen (default slot): -->
		<div v-html="vpWidgetData.partialHtml"
			style="height:100%;"
		></div>

	</eui-panel>
</template>


<!--<style scoped>
	/* ################################################################################################################ */
	/*! Scoped styles. Created by the leverantorsreskontrawidget component (style embedded in .vue): */

	/*
If you want a selector in scoped styles to be "deep", i.e. affecting child components, you can use the >>> combinator:
.a >>> .b { ...
*/

	._eui-panel >>> .somh1
	{
		transition: font-size .2s ease;
	}

	._eui-panel.b-350-plus >>> .somh1
	{
		color: red !important; /* Todo: important bara för att inline styles anv tills vidare. Ska ersättas med css. */
		font-size: 3.5rem;
	}

	._eui-panel.h-260-plus >>> .kontentan
	{
		flex-direction: column !important; /* Todo: important bara för att inline styles anv tills vidare. Ska ersättas med css. */
	}
</style>-->


<script>
	// ################################################################################################################

	import euiPanel from 'v-components/euiPanel';
	import { ssoGeneriskWidgetMixin } from 'v-mixins/ssoGeneriskWidgetMixin';

	//// Klon av originalet på https://github.com/Kelin2025/vue-responsive-components:
	//import { ResponsiveContainerMixin } from 'ResponsiveContainer';

	export default {
		name: 'leverantorsreskontrawidget',

		// All generisk widgetfunktionalitet, se 'ssoGeneriskWidgetMixin.js'.
		mixins: [ssoGeneriskWidgetMixin],

		// mixins: [ ResponsiveContainerMixin ],

		//breakpoints: {
		//	bredd350plus: el => el.width >= 350,
		//	hojd260plus: el => el.height >= 260,
		//},

		// Lokalt registrarade komponenter
		components: {
			[euiPanel.name]: euiPanel,
		},

		//// Utöver de från mixin ovan:
		//props: {
		//},


		//== Lifecycle hooks  ================================================================================================================

	}
</script>

